import {css, cx} from "@panda/css";

import {GardenIcon, SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface Props {
    disabled: boolean;
    layout?: "column" | "inline";
    onSelectQuestion: (question: string) => void;
}

const quickQuestions = [
    {
        text: "Poszukaj najtańszych mieszkań w tej lokalizacji",
        icon: <SearchIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
    },
    {
        text: "Powiedz mi więcej o plusach i minusach tej lokalizacji",
        icon: <GardenIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
    }
] as const;

export function SemanticSearchQuickQuestions(props: Props) {
    const {disabled, layout = "column", onSelectQuestion} = props;
    const isInlineLayout = layout === "inline";

    return (
        <div className={cx(quickQuestionsWrapper, isInlineLayout ? quickQuestionsWrapperInline : quickQuestionsWrapperColumn)}>
            {quickQuestions.map((question) => (
                <button
                    type="button"
                    key={question.text}
                    className={cx(quickQuestionButton, isInlineLayout && quickQuestionButtonInline)}
                    disabled={disabled}
                    onClick={() => onSelectQuestion(question.text)}
                >
                    <span className={quickQuestionIcon} aria-hidden="true">
                        {question.icon}
                    </span>

                    <Text variant="info_txt_1" as="span" className={quickQuestionText}>
                        {question.text}
                    </Text>
                </button>
            ))}
        </div>
    );
}

const quickQuestionsWrapper = css({
    display: "flex",
    width: "100%",
    gap: 1,
    mb: 5
});

const quickQuestionsWrapperColumn = css({
    flexDirection: "column"
});

const quickQuestionsWrapperInline = css({
    flexDirection: "row"
});

const quickQuestionButton = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "48px",
    gap: 0.5,
    px: 1,
    py: 1.5,
    border: "1px solid #000",
    borderRadius: 1,
    color: "var(--colors-gray-900)",
    boxShadow: "var(--shadow-1)",
    cursor: "pointer",
    textAlign: "left",

    _hover: {
        backgroundColor: "var(--colors-gray-100)"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    },

    _disabled: {
        cursor: "not-allowed",
        opacity: 0.55
    }
});

const quickQuestionButtonInline = css({
    flex: "1 1 0",
    minWidth: 0
});

const quickQuestionIcon = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    flex: "0 0 auto"
});

const quickQuestionText = css({
    flex: "1 1 auto",
    minWidth: 0,
    color: "var(--colors-gray-900)"
});
import {css, cx} from "@panda/css";

import {GardenIcon, SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

interface Props {
    disabled: boolean;
    layout?: "column" | "inline";
    onSelectQuestion: (question: string) => void;
}

const quickQuestions = [
    {
        text: "Poszukaj najtańszych mieszkań w tej lokalizacji",
        icon: <SearchIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
    },
    {
        text: "Powiedz mi więcej o plusach i minusach tej lokalizacji",
        icon: <GardenIcon size="2.4" wrapperSize="2.4" wrapperColor="transparent" />
    }
] as const;

export function SemanticSearchQuickQuestions(props: Props) {
    const {disabled, layout = "column", onSelectQuestion} = props;
    const isInlineLayout = layout === "inline";

    return (
        <div className={cx(quickQuestionsWrapper, isInlineLayout ? quickQuestionsWrapperInline : quickQuestionsWrapperColumn)}>
            {quickQuestions.map((question) => (
                <button
                    type="button"
                    key={question.text}
                    className={cx(quickQuestionButton, isInlineLayout && quickQuestionButtonInline)}
                    disabled={disabled}
                    onClick={() => onSelectQuestion(question.text)}
                >
                    <span className={quickQuestionIcon} aria-hidden="true">
                        {question.icon}
                    </span>

                    <Text variant="info_txt_1" as="span" className={quickQuestionText}>
                        {question.text}
                    </Text>
                </button>
            ))}
        </div>
    );
}

const quickQuestionsWrapper = css({
    display: "flex",
    width: "100%",
    gap: 1,
    mb: 5
});

const quickQuestionsWrapperColumn = css({
    flexDirection: "column"
});

const quickQuestionsWrapperInline = css({
    flexDirection: "row"
});

const quickQuestionButton = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "48px",
    gap: 0.5,
    px: 1,
    py: 1.5,
    border: "1px solid #000",
    borderRadius: 1,
    color: "var(--colors-gray-900)",
    boxShadow: "var(--shadow-1)",
    cursor: "pointer",
    textAlign: "left",

    _hover: {
        backgroundColor: "var(--colors-gray-100)"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    },

    _disabled: {
        cursor: "not-allowed",
        opacity: 0.55
    }
});

const quickQuestionButtonInline = css({
    flex: "1 1 0",
    minWidth: 0
});

const quickQuestionIcon = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    flex: "0 0 auto"
});

const quickQuestionText = css({
    flex: "1 1 auto",
    minWidth: 0,
    color: "var(--colors-gray-900)"
});
